// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LMDialogButtonKey, LMUniqueIdService } from '@utils/index';
import { LMGenAIPromptDialogComponent } from '@modal/lm-genai-prompt-dialog.component';
import { LMModel } from '@form/model';
import { LMGenAIPromptGeneratedEvent } from '@modal/lm-genai-prompt-dialog';
import { LMFormatUtilService, LMModalDialogWrapperRef, LMModalWrapperService } from '@app/services';

export enum GenAIPromptDialogStatus {
  RESPONSE_CANCEL = 0,
  RESPONSE_OK
}

export interface GenAIPromptDialogResult {
  status: GenAIPromptDialogStatus;
  generated?: string;
  isRephrase?: boolean;
  fieldId?: string;
  dataView?: LMDataView;
  model?: LMModel;
}

@Injectable()
export class LMGenAIPromptDialogService {

  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmModalWrapperService: LMModalWrapperService
  ) {}

  /**
   * Prompt Gen AI Prompt dialog
   * @param viewContainerRef
   *
   * @return Observable<any>
   */
  public promptGenAIDialog(url?: string, fieldId?: string, lmModel?: LMModel, fieldLabel?: string) : Observable<any> {
    const prompt: Observable<GenAIPromptDialogResult> = new Observable<GenAIPromptDialogResult> (observer => {
      let genAIComponent: LMGenAIPromptDialogComponent;
      let dialog: LMModalDialogWrapperRef<any> = undefined;
      let dialogFieldTitle = fieldLabel == undefined || fieldLabel.length == 0 ? Soho.Locale.translate('GenerateAIDialogNoLabelTitle') : this.lmFormatUtilService.formatMessage(Soho.Locale.translate('GenerateAIDialogTitle'), fieldLabel);

      let isRephraseMode = false;
      const selectedText = window.getSelection().toString(); // will be empty string if nothing selected

      const attributes: SohoAttributesArray = [ {
        name: 'data-automation-id',
        value: 'lm-gen-ai-modal'
      } ];

      const sohoModalOptions: SohoModalOptions = {
        fullsize: false,
        attributes,
        cssClass: this.getCSSClass(),
      };

      const dialogId = 'GenAIPrompt';
      let buttons = [
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.APPEND ]),
          text: Soho.Locale.translate(LMDialogButtonKey.APPEND),
          click: (e, modal) => {
            {
              dialog.close(<GenAIPromptDialogResult> {
                status: GenAIPromptDialogStatus.RESPONSE_OK,
                generated: genAIComponent.getGeneratedText(),
                fieldId: genAIComponent.fieldId,
                model: genAIComponent.model,
                dataView: genAIComponent.dataView
              });
            }
          },
          validate: true,
          isDefault: true,
          disabled: true
        }
      ];

      if (selectedText.length > 0) {
        isRephraseMode = true;
        dialogFieldTitle = Soho.Locale.translate('GenAIRephraseText');
        buttons = [
          {
            id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.USEREPHRASEDTEXT ]),
            text: Soho.Locale.translate(LMDialogButtonKey.USEREPHRASEDTEXT),
            click: (e, modal) => {
              {
                dialog.close(<GenAIPromptDialogResult> {
                  status: GenAIPromptDialogStatus.RESPONSE_OK,
                  generated: genAIComponent.getGeneratedText(),
                  fieldId: genAIComponent.fieldId,
                  model: genAIComponent.model,
                  dataView: genAIComponent.dataView
                });
              }
            },
            validate: true,
            isDefault: true,
            disabled: true
          }
        ];
      }

      dialog = this.lmModalWrapperService
        .modal(LMGenAIPromptDialogComponent, sohoModalOptions)
        .showCloseBtn(true)
        .buttons(buttons)
        .title(dialogFieldTitle)
        .iconClass('info')
        .isAlert(false)
        .open()
        .apply((genAIForm: LMGenAIPromptDialogComponent) => {
          genAIComponent = genAIForm;
          genAIComponent.dataView = lmModel.getData();
          genAIComponent.fieldId = fieldId;
          genAIComponent.model = lmModel;
          genAIComponent.url = url;
          genAIComponent.isRephraseMode = isRephraseMode;
          genAIComponent.genAIPrompt.value = selectedText;
          genAIComponent.generatedTextEvent.subscribe((event: LMGenAIPromptGeneratedEvent) => {
            if (event && event.valid) {
              dialog.buttonsetAPI.at(0).disabled = false;
            }
          });
        })
        .afterClose(result => {
          if (!result) {
            result = <GenAIPromptDialogResult>{
              status: GenAIPromptDialogStatus.RESPONSE_CANCEL
            };
          }
          observer.next(result);
          observer.complete();
        });
    });
    return prompt;
  }
  private getCSSClass(): string {
    const cssClass = [ 'lm-action-form-dialog' ];
    cssClass.push('lm-full-tabbed-action-form');

    return cssClass.join(' ');
  }
}
